import { DialogInfo, useDialogContext } from 'context/dialog-context';

interface FnCallback {
    (): void;
}

export const useGenericAlert = () => {
    const { update } = useDialogContext();

    return (
        { contentText, cancelText = 'Cancel', successText = 'Done' }: Omit<DialogInfo, 'alertVisible' | 'action'>,
        handleSuccess?: FnCallback,
        handleCancel?: FnCallback
    ) => {
        update('__data__', {
            dialogData: {
                alertVisible: true,
                contentText,
                cancelText,
                successText,
            },
            onSuccess: handleSuccess,
            onCancel: handleCancel,
        });
    };
};
